
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    if (!router) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    for (const route of mod.default || mod) {
      router.addRoute(route)
    }
    router.replace('')
  })
}

export function handleHotUpdate(_router) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
  }
}
import { default as icons_45pageJ0GqbNaF7YMeta } from "/data/node-v18/workspace/djt-h5/h5-support-Nuxt-fra-prod/node_modules/.pnpm/@nuxtjs+svg-sprite@1.0.2/node_modules/@nuxtjs/svg-sprite/dist/runtime/components/icons-page.vue?macro=true";
import { default as _404Eogs1QJTGzMeta } from "/data/node-v18/workspace/djt-h5/h5-support-Nuxt-fra-prod/packages/support-pc/pages/[country]-[lang]/404.vue?macro=true";
import { default as indexLLtkMbISo9Meta } from "/data/node-v18/workspace/djt-h5/h5-support-Nuxt-fra-prod/packages/support-pc/pages/[country]-[lang]/accessoriesPrice/index.vue?macro=true";
import { default as index9DZOzcP97CMeta } from "/data/node-v18/workspace/djt-h5/h5-support-Nuxt-fra-prod/packages/support-pc/pages/[country]-[lang]/accessoryPrices/components/index.ts?macro=true";
import { default as MayNeedjMrirpusoQMeta } from "/data/node-v18/workspace/djt-h5/h5-support-Nuxt-fra-prod/packages/support-pc/pages/[country]-[lang]/accessoryPrices/components/MayNeed.vue?macro=true";
import { default as ServicePolicy38eITiUI56Meta } from "/data/node-v18/workspace/djt-h5/h5-support-Nuxt-fra-prod/packages/support-pc/pages/[country]-[lang]/accessoryPrices/components/ServicePolicy.vue?macro=true";
import { default as hookdvnxkeYsFzMeta } from "/data/node-v18/workspace/djt-h5/h5-support-Nuxt-fra-prod/packages/support-pc/pages/[country]-[lang]/accessoryPrices/hook.ts?macro=true";
import { default as indexPgWqXmBgdCMeta } from "/data/node-v18/workspace/djt-h5/h5-support-Nuxt-fra-prod/packages/support-pc/pages/[country]-[lang]/accessoryPrices/index.vue?macro=true";
import { default as searchZ2nujqkWo8Meta } from "/data/node-v18/workspace/djt-h5/h5-support-Nuxt-fra-prod/packages/support-pc/pages/[country]-[lang]/accessoryPrices/search.vue?macro=true";
import { default as stepOnemXwIlguectMeta } from "/data/node-v18/workspace/djt-h5/h5-support-Nuxt-fra-prod/packages/support-pc/pages/[country]-[lang]/coc/components/stepOne.vue?macro=true";
import { default as stepThreeaQdQbI6L5LMeta } from "/data/node-v18/workspace/djt-h5/h5-support-Nuxt-fra-prod/packages/support-pc/pages/[country]-[lang]/coc/components/stepThree.vue?macro=true";
import { default as stepTwoCRLVYY36zXMeta } from "/data/node-v18/workspace/djt-h5/h5-support-Nuxt-fra-prod/packages/support-pc/pages/[country]-[lang]/coc/components/stepTwo.vue?macro=true";
import { default as indexz8ic5ZML01Meta } from "/data/node-v18/workspace/djt-h5/h5-support-Nuxt-fra-prod/packages/support-pc/pages/[country]-[lang]/coc/index.vue?macro=true";
import { default as indexHgiA0Lr6CVMeta } from "/data/node-v18/workspace/djt-h5/h5-support-Nuxt-fra-prod/packages/support-pc/pages/[country]-[lang]/dealerService/index.vue?macro=true";
import { default as indexZrVCOiC6miMeta } from "/data/node-v18/workspace/djt-h5/h5-support-Nuxt-fra-prod/packages/support-pc/pages/[country]-[lang]/g30RecallNotice/index.vue?macro=true";
import { default as indexOvHuAukEy9Meta } from "/data/node-v18/workspace/djt-h5/h5-support-Nuxt-fra-prod/packages/support-pc/pages/[country]-[lang]/index.vue?macro=true";
import { default as listjXWkbIk9xlMeta } from "/data/node-v18/workspace/djt-h5/h5-support-Nuxt-fra-prod/packages/support-pc/pages/[country]-[lang]/instructions/list.vue?macro=true";
import { default as indexISDLbzupfbMeta } from "/data/node-v18/workspace/djt-h5/h5-support-Nuxt-fra-prod/packages/support-pc/pages/[country]-[lang]/international/index.vue?macro=true";
import { default as detailwF9mfWVKVVMeta } from "/data/node-v18/workspace/djt-h5/h5-support-Nuxt-fra-prod/packages/support-pc/pages/[country]-[lang]/mailRepair/detail.vue?macro=true";
import { default as indexTpT7oPrHtvMeta } from "/data/node-v18/workspace/djt-h5/h5-support-Nuxt-fra-prod/packages/support-pc/pages/[country]-[lang]/mailRepair/index.vue?macro=true";
import { default as listbkBlveLXXHMeta } from "/data/node-v18/workspace/djt-h5/h5-support-Nuxt-fra-prod/packages/support-pc/pages/[country]-[lang]/mailRepair/list.vue?macro=true";
import { default as questionClassifiyaPMZbhuhPaMeta } from "/data/node-v18/workspace/djt-h5/h5-support-Nuxt-fra-prod/packages/support-pc/pages/[country]-[lang]/manual/questionClassifiy.vue?macro=true";
import { default as questionDetaill0StJhIbcXMeta } from "/data/node-v18/workspace/djt-h5/h5-support-Nuxt-fra-prod/packages/support-pc/pages/[country]-[lang]/manual/questionDetail.vue?macro=true";
import { default as indexZNWLfpNXCFMeta } from "/data/node-v18/workspace/djt-h5/h5-support-Nuxt-fra-prod/packages/support-pc/pages/[country]-[lang]/onlineChat/index.vue?macro=true";
import { default as indexNWV33SL2nLMeta } from "/data/node-v18/workspace/djt-h5/h5-support-Nuxt-fra-prod/packages/support-pc/pages/[country]-[lang]/onlineRepair/index.vue?macro=true";
import { default as success5RdTnV9WrcMeta } from "/data/node-v18/workspace/djt-h5/h5-support-Nuxt-fra-prod/packages/support-pc/pages/[country]-[lang]/onlineRepair/success.vue?macro=true";
import { default as indexHwaADoCOoIMeta } from "/data/node-v18/workspace/djt-h5/h5-support-Nuxt-fra-prod/packages/support-pc/pages/[country]-[lang]/pdf/index.vue?macro=true";
import { default as listPLPMfoplk0Meta } from "/data/node-v18/workspace/djt-h5/h5-support-Nuxt-fra-prod/packages/support-pc/pages/[country]-[lang]/policy/list.vue?macro=true";
import { default as modelSelect1uwHaIYt98Meta } from "/data/node-v18/workspace/djt-h5/h5-support-Nuxt-fra-prod/packages/support-pc/pages/[country]-[lang]/product/modelSelect.vue?macro=true";
import { default as seriesSelectZOtUmrmTBTMeta } from "/data/node-v18/workspace/djt-h5/h5-support-Nuxt-fra-prod/packages/support-pc/pages/[country]-[lang]/product/seriesSelect.vue?macro=true";
import { default as indexj5rXMaGOhBMeta } from "/data/node-v18/workspace/djt-h5/h5-support-Nuxt-fra-prod/packages/support-pc/pages/[country]-[lang]/recall/index.vue?macro=true";
import { default as successJjk1rspp4hMeta } from "/data/node-v18/workspace/djt-h5/h5-support-Nuxt-fra-prod/packages/support-pc/pages/[country]-[lang]/recall/success.vue?macro=true";
import { default as indexgl5Iwnu8znMeta } from "/data/node-v18/workspace/djt-h5/h5-support-Nuxt-fra-prod/packages/support-pc/pages/[country]-[lang]/regulations/index.vue?macro=true";
import { default as download7cQFQIJEbEMeta } from "/data/node-v18/workspace/djt-h5/h5-support-Nuxt-fra-prod/packages/support-pc/pages/[country]-[lang]/search/download.vue?macro=true";
import { default as index1S4NZElBNnMeta } from "/data/node-v18/workspace/djt-h5/h5-support-Nuxt-fra-prod/packages/support-pc/pages/[country]-[lang]/search/index.vue?macro=true";
import { default as questionDetaileigLUou9dFMeta } from "/data/node-v18/workspace/djt-h5/h5-support-Nuxt-fra-prod/packages/support-pc/pages/[country]-[lang]/search/questionDetail.vue?macro=true";
import { default as selfRepairDetail2EEWH6QfUrMeta } from "/data/node-v18/workspace/djt-h5/h5-support-Nuxt-fra-prod/packages/support-pc/pages/[country]-[lang]/search/selfRepairDetail.vue?macro=true";
import { default as vehicleVideoiwhsXwsyZ9Meta } from "/data/node-v18/workspace/djt-h5/h5-support-Nuxt-fra-prod/packages/support-pc/pages/[country]-[lang]/search/vehicleVideo.vue?macro=true";
import { default as indexh7GihoknmqMeta } from "/data/node-v18/workspace/djt-h5/h5-support-Nuxt-fra-prod/packages/support-pc/pages/[country]-[lang]/selfRepair/index.vue?macro=true";
import { default as videoDetail3yf2rI0cYcMeta } from "/data/node-v18/workspace/djt-h5/h5-support-Nuxt-fra-prod/packages/support-pc/pages/[country]-[lang]/selfRepair/videoDetail.vue?macro=true";
import { default as videoListne6ihqcervMeta } from "/data/node-v18/workspace/djt-h5/h5-support-Nuxt-fra-prod/packages/support-pc/pages/[country]-[lang]/selfRepair/videoList.vue?macro=true";
import { default as CustomCell6S3Ul6T5rkMeta } from "/data/node-v18/workspace/djt-h5/h5-support-Nuxt-fra-prod/packages/support-pc/pages/[country]-[lang]/ServiceCenter/components/CustomCell.vue?macro=true";
import { default as CustomDetailLugCB9DxKWMeta } from "/data/node-v18/workspace/djt-h5/h5-support-Nuxt-fra-prod/packages/support-pc/pages/[country]-[lang]/ServiceCenter/components/CustomDetail.vue?macro=true";
import { default as CustomPopupFEMAohnshLMeta } from "/data/node-v18/workspace/djt-h5/h5-support-Nuxt-fra-prod/packages/support-pc/pages/[country]-[lang]/ServiceCenter/components/CustomPopup.vue?macro=true";
import { default as CustomSearchoeNhiY8TiBMeta } from "/data/node-v18/workspace/djt-h5/h5-support-Nuxt-fra-prod/packages/support-pc/pages/[country]-[lang]/ServiceCenter/components/CustomSearch.vue?macro=true";
import { default as indexrlwzL80vUcMeta } from "/data/node-v18/workspace/djt-h5/h5-support-Nuxt-fra-prod/packages/support-pc/pages/[country]-[lang]/ServiceCenter/index.vue?macro=true";
import { default as indexfZjdp8vajdMeta } from "/data/node-v18/workspace/djt-h5/h5-support-Nuxt-fra-prod/packages/support-pc/pages/[country]-[lang]/serviceNetwork/index.vue?macro=true";
import { default as indexL4AO5aEsEGMeta } from "/data/node-v18/workspace/djt-h5/h5-support-Nuxt-fra-prod/packages/support-pc/pages/[country]-[lang]/vehicle/index.vue?macro=true";
import { default as video8KInMu2Y8NMeta } from "/data/node-v18/workspace/djt-h5/h5-support-Nuxt-fra-prod/packages/support-pc/pages/[country]-[lang]/vehicle/video.vue?macro=true";
import { default as videoDetailDCoG60mHtxMeta } from "/data/node-v18/workspace/djt-h5/h5-support-Nuxt-fra-prod/packages/support-pc/pages/[country]-[lang]/vehicle/videoDetail.vue?macro=true";
export default [
  {
    name: "icons-page",
    path: "/_icons",
    meta: {"layout":"svg-sprite"},
    component: () => import("/data/node-v18/workspace/djt-h5/h5-support-Nuxt-fra-prod/node_modules/.pnpm/@nuxtjs+svg-sprite@1.0.2/node_modules/@nuxtjs/svg-sprite/dist/runtime/components/icons-page.vue")
  },
  {
    name: "country-lang-404",
    path: "/:country()-:lang()/404",
    component: () => import("/data/node-v18/workspace/djt-h5/h5-support-Nuxt-fra-prod/packages/support-pc/pages/[country]-[lang]/404.vue")
  },
  {
    name: "country-lang-accessoriesPrice",
    path: "/:country()-:lang()/accessoriesPrice",
    component: () => import("/data/node-v18/workspace/djt-h5/h5-support-Nuxt-fra-prod/packages/support-pc/pages/[country]-[lang]/accessoriesPrice/index.vue")
  },
  {
    name: "country-lang-accessoryPrices-components",
    path: "/:country()-:lang()/accessoryPrices/components",
    component: () => import("/data/node-v18/workspace/djt-h5/h5-support-Nuxt-fra-prod/packages/support-pc/pages/[country]-[lang]/accessoryPrices/components/index.ts")
  },
  {
    name: "country-lang-accessoryPrices-components-MayNeed",
    path: "/:country()-:lang()/accessoryPrices/components/MayNeed",
    component: () => import("/data/node-v18/workspace/djt-h5/h5-support-Nuxt-fra-prod/packages/support-pc/pages/[country]-[lang]/accessoryPrices/components/MayNeed.vue")
  },
  {
    name: "country-lang-accessoryPrices-components-ServicePolicy",
    path: "/:country()-:lang()/accessoryPrices/components/ServicePolicy",
    component: () => import("/data/node-v18/workspace/djt-h5/h5-support-Nuxt-fra-prod/packages/support-pc/pages/[country]-[lang]/accessoryPrices/components/ServicePolicy.vue")
  },
  {
    name: "country-lang-accessoryPrices-hook",
    path: "/:country()-:lang()/accessoryPrices/hook",
    component: () => import("/data/node-v18/workspace/djt-h5/h5-support-Nuxt-fra-prod/packages/support-pc/pages/[country]-[lang]/accessoryPrices/hook.ts")
  },
  {
    name: "country-lang-accessoryPrices",
    path: "/:country()-:lang()/accessoryPrices",
    component: () => import("/data/node-v18/workspace/djt-h5/h5-support-Nuxt-fra-prod/packages/support-pc/pages/[country]-[lang]/accessoryPrices/index.vue")
  },
  {
    name: "country-lang-accessoryPrices-search",
    path: "/:country()-:lang()/accessoryPrices/search",
    component: () => import("/data/node-v18/workspace/djt-h5/h5-support-Nuxt-fra-prod/packages/support-pc/pages/[country]-[lang]/accessoryPrices/search.vue")
  },
  {
    name: "country-lang-coc-components-stepOne",
    path: "/:country()-:lang()/coc/components/stepOne",
    component: () => import("/data/node-v18/workspace/djt-h5/h5-support-Nuxt-fra-prod/packages/support-pc/pages/[country]-[lang]/coc/components/stepOne.vue")
  },
  {
    name: "country-lang-coc-components-stepThree",
    path: "/:country()-:lang()/coc/components/stepThree",
    component: () => import("/data/node-v18/workspace/djt-h5/h5-support-Nuxt-fra-prod/packages/support-pc/pages/[country]-[lang]/coc/components/stepThree.vue")
  },
  {
    name: "country-lang-coc-components-stepTwo",
    path: "/:country()-:lang()/coc/components/stepTwo",
    component: () => import("/data/node-v18/workspace/djt-h5/h5-support-Nuxt-fra-prod/packages/support-pc/pages/[country]-[lang]/coc/components/stepTwo.vue")
  },
  {
    name: "country-lang-coc",
    path: "/:country()-:lang()/coc",
    meta: indexz8ic5ZML01Meta || {},
    component: () => import("/data/node-v18/workspace/djt-h5/h5-support-Nuxt-fra-prod/packages/support-pc/pages/[country]-[lang]/coc/index.vue")
  },
  {
    name: "country-lang-dealerService",
    path: "/:country()-:lang()/dealerService",
    component: () => import("/data/node-v18/workspace/djt-h5/h5-support-Nuxt-fra-prod/packages/support-pc/pages/[country]-[lang]/dealerService/index.vue")
  },
  {
    name: "country-lang-g30RecallNotice",
    path: "/:country()-:lang()/g30RecallNotice",
    meta: indexZrVCOiC6miMeta || {},
    component: () => import("/data/node-v18/workspace/djt-h5/h5-support-Nuxt-fra-prod/packages/support-pc/pages/[country]-[lang]/g30RecallNotice/index.vue")
  },
  {
    name: "country-lang",
    path: "/:country()-:lang()",
    component: () => import("/data/node-v18/workspace/djt-h5/h5-support-Nuxt-fra-prod/packages/support-pc/pages/[country]-[lang]/index.vue")
  },
  {
    name: "country-lang-instructions-list",
    path: "/:country()-:lang()/instructions/list",
    component: () => import("/data/node-v18/workspace/djt-h5/h5-support-Nuxt-fra-prod/packages/support-pc/pages/[country]-[lang]/instructions/list.vue")
  },
  {
    name: "country-lang-international",
    path: "/:country()-:lang()/international",
    component: () => import("/data/node-v18/workspace/djt-h5/h5-support-Nuxt-fra-prod/packages/support-pc/pages/[country]-[lang]/international/index.vue")
  },
  {
    name: "country-lang-mailRepair-detail",
    path: "/:country()-:lang()/mailRepair/detail",
    component: () => import("/data/node-v18/workspace/djt-h5/h5-support-Nuxt-fra-prod/packages/support-pc/pages/[country]-[lang]/mailRepair/detail.vue")
  },
  {
    name: "country-lang-mailRepair",
    path: "/:country()-:lang()/mailRepair",
    component: () => import("/data/node-v18/workspace/djt-h5/h5-support-Nuxt-fra-prod/packages/support-pc/pages/[country]-[lang]/mailRepair/index.vue")
  },
  {
    name: "country-lang-mailRepair-list",
    path: "/:country()-:lang()/mailRepair/list",
    component: () => import("/data/node-v18/workspace/djt-h5/h5-support-Nuxt-fra-prod/packages/support-pc/pages/[country]-[lang]/mailRepair/list.vue")
  },
  {
    name: "country-lang-manual-questionClassifiy",
    path: "/:country()-:lang()/manual/questionClassifiy",
    component: () => import("/data/node-v18/workspace/djt-h5/h5-support-Nuxt-fra-prod/packages/support-pc/pages/[country]-[lang]/manual/questionClassifiy.vue")
  },
  {
    name: "country-lang-manual-questionDetail",
    path: "/:country()-:lang()/manual/questionDetail",
    component: () => import("/data/node-v18/workspace/djt-h5/h5-support-Nuxt-fra-prod/packages/support-pc/pages/[country]-[lang]/manual/questionDetail.vue")
  },
  {
    name: "country-lang-onlineChat",
    path: "/:country()-:lang()/onlineChat",
    component: () => import("/data/node-v18/workspace/djt-h5/h5-support-Nuxt-fra-prod/packages/support-pc/pages/[country]-[lang]/onlineChat/index.vue")
  },
  {
    name: "country-lang-onlineRepair",
    path: "/:country()-:lang()/onlineRepair",
    component: () => import("/data/node-v18/workspace/djt-h5/h5-support-Nuxt-fra-prod/packages/support-pc/pages/[country]-[lang]/onlineRepair/index.vue")
  },
  {
    name: "country-lang-onlineRepair-success",
    path: "/:country()-:lang()/onlineRepair/success",
    component: () => import("/data/node-v18/workspace/djt-h5/h5-support-Nuxt-fra-prod/packages/support-pc/pages/[country]-[lang]/onlineRepair/success.vue")
  },
  {
    name: "country-lang-pdf",
    path: "/:country()-:lang()/pdf",
    component: () => import("/data/node-v18/workspace/djt-h5/h5-support-Nuxt-fra-prod/packages/support-pc/pages/[country]-[lang]/pdf/index.vue")
  },
  {
    name: "country-lang-policy-list",
    path: "/:country()-:lang()/policy/list",
    component: () => import("/data/node-v18/workspace/djt-h5/h5-support-Nuxt-fra-prod/packages/support-pc/pages/[country]-[lang]/policy/list.vue")
  },
  {
    name: "country-lang-product-modelSelect",
    path: "/:country()-:lang()/product/modelSelect",
    component: () => import("/data/node-v18/workspace/djt-h5/h5-support-Nuxt-fra-prod/packages/support-pc/pages/[country]-[lang]/product/modelSelect.vue")
  },
  {
    name: "country-lang-product-seriesSelect",
    path: "/:country()-:lang()/product/seriesSelect",
    component: () => import("/data/node-v18/workspace/djt-h5/h5-support-Nuxt-fra-prod/packages/support-pc/pages/[country]-[lang]/product/seriesSelect.vue")
  },
  {
    name: "country-lang-recall",
    path: "/:country()-:lang()/recall",
    component: () => import("/data/node-v18/workspace/djt-h5/h5-support-Nuxt-fra-prod/packages/support-pc/pages/[country]-[lang]/recall/index.vue")
  },
  {
    name: "country-lang-recall-success",
    path: "/:country()-:lang()/recall/success",
    meta: successJjk1rspp4hMeta || {},
    component: () => import("/data/node-v18/workspace/djt-h5/h5-support-Nuxt-fra-prod/packages/support-pc/pages/[country]-[lang]/recall/success.vue")
  },
  {
    name: "country-lang-regulations",
    path: "/:country()-:lang()/regulations",
    component: () => import("/data/node-v18/workspace/djt-h5/h5-support-Nuxt-fra-prod/packages/support-pc/pages/[country]-[lang]/regulations/index.vue")
  },
  {
    name: "country-lang-search-download",
    path: "/:country()-:lang()/search/download",
    component: () => import("/data/node-v18/workspace/djt-h5/h5-support-Nuxt-fra-prod/packages/support-pc/pages/[country]-[lang]/search/download.vue")
  },
  {
    name: "country-lang-search",
    path: "/:country()-:lang()/search",
    component: () => import("/data/node-v18/workspace/djt-h5/h5-support-Nuxt-fra-prod/packages/support-pc/pages/[country]-[lang]/search/index.vue")
  },
  {
    name: "country-lang-search-questionDetail",
    path: "/:country()-:lang()/search/questionDetail",
    component: () => import("/data/node-v18/workspace/djt-h5/h5-support-Nuxt-fra-prod/packages/support-pc/pages/[country]-[lang]/search/questionDetail.vue")
  },
  {
    name: "country-lang-search-selfRepairDetail",
    path: "/:country()-:lang()/search/selfRepairDetail",
    component: () => import("/data/node-v18/workspace/djt-h5/h5-support-Nuxt-fra-prod/packages/support-pc/pages/[country]-[lang]/search/selfRepairDetail.vue")
  },
  {
    name: "country-lang-search-vehicleVideo",
    path: "/:country()-:lang()/search/vehicleVideo",
    component: () => import("/data/node-v18/workspace/djt-h5/h5-support-Nuxt-fra-prod/packages/support-pc/pages/[country]-[lang]/search/vehicleVideo.vue")
  },
  {
    name: "country-lang-selfRepair",
    path: "/:country()-:lang()/selfRepair",
    component: () => import("/data/node-v18/workspace/djt-h5/h5-support-Nuxt-fra-prod/packages/support-pc/pages/[country]-[lang]/selfRepair/index.vue")
  },
  {
    name: "country-lang-selfRepair-videoDetail",
    path: "/:country()-:lang()/selfRepair/videoDetail",
    component: () => import("/data/node-v18/workspace/djt-h5/h5-support-Nuxt-fra-prod/packages/support-pc/pages/[country]-[lang]/selfRepair/videoDetail.vue")
  },
  {
    name: "country-lang-selfRepair-videoList",
    path: "/:country()-:lang()/selfRepair/videoList",
    meta: videoListne6ihqcervMeta || {},
    component: () => import("/data/node-v18/workspace/djt-h5/h5-support-Nuxt-fra-prod/packages/support-pc/pages/[country]-[lang]/selfRepair/videoList.vue")
  },
  {
    name: "country-lang-ServiceCenter-components-CustomCell",
    path: "/:country()-:lang()/ServiceCenter/components/CustomCell",
    component: () => import("/data/node-v18/workspace/djt-h5/h5-support-Nuxt-fra-prod/packages/support-pc/pages/[country]-[lang]/ServiceCenter/components/CustomCell.vue")
  },
  {
    name: "country-lang-ServiceCenter-components-CustomDetail",
    path: "/:country()-:lang()/ServiceCenter/components/CustomDetail",
    component: () => import("/data/node-v18/workspace/djt-h5/h5-support-Nuxt-fra-prod/packages/support-pc/pages/[country]-[lang]/ServiceCenter/components/CustomDetail.vue")
  },
  {
    name: "country-lang-ServiceCenter-components-CustomPopup",
    path: "/:country()-:lang()/ServiceCenter/components/CustomPopup",
    component: () => import("/data/node-v18/workspace/djt-h5/h5-support-Nuxt-fra-prod/packages/support-pc/pages/[country]-[lang]/ServiceCenter/components/CustomPopup.vue")
  },
  {
    name: "country-lang-ServiceCenter-components-CustomSearch",
    path: "/:country()-:lang()/ServiceCenter/components/CustomSearch",
    component: () => import("/data/node-v18/workspace/djt-h5/h5-support-Nuxt-fra-prod/packages/support-pc/pages/[country]-[lang]/ServiceCenter/components/CustomSearch.vue")
  },
  {
    name: "country-lang-ServiceCenter",
    path: "/:country()-:lang()/ServiceCenter",
    meta: indexrlwzL80vUcMeta || {},
    component: () => import("/data/node-v18/workspace/djt-h5/h5-support-Nuxt-fra-prod/packages/support-pc/pages/[country]-[lang]/ServiceCenter/index.vue")
  },
  {
    name: "country-lang-serviceNetwork",
    path: "/:country()-:lang()/serviceNetwork",
    component: () => import("/data/node-v18/workspace/djt-h5/h5-support-Nuxt-fra-prod/packages/support-pc/pages/[country]-[lang]/serviceNetwork/index.vue")
  },
  {
    name: "country-lang-vehicle",
    path: "/:country()-:lang()/vehicle",
    component: () => import("/data/node-v18/workspace/djt-h5/h5-support-Nuxt-fra-prod/packages/support-pc/pages/[country]-[lang]/vehicle/index.vue")
  },
  {
    name: "country-lang-vehicle-video",
    path: "/:country()-:lang()/vehicle/video",
    component: () => import("/data/node-v18/workspace/djt-h5/h5-support-Nuxt-fra-prod/packages/support-pc/pages/[country]-[lang]/vehicle/video.vue")
  },
  {
    name: "country-lang-vehicle-videoDetail",
    path: "/:country()-:lang()/vehicle/videoDetail",
    component: () => import("/data/node-v18/workspace/djt-h5/h5-support-Nuxt-fra-prod/packages/support-pc/pages/[country]-[lang]/vehicle/videoDetail.vue")
  }
]